import { Dispatch, SetStateAction, useCallback } from "react";

import { useAppSelector } from "@/redux/hooks";
import { useGetEmailSignatureDefaultQuery } from "@/pages/Private/redux/copywritingSettings/copywritingSettings.api";
import { emailSignatureDefaultSelector } from "@/pages/Private/redux/copywritingSettings/copywritingSettings.slice";

import { Draft } from "./inboxDraft.types";

/**
 * The composer's Include signature state (PREC-4401): the company's default, which every email
 * draft starts from, and the setter for the active draft's own choice. Until the default has
 * loaded it reads off, so nothing is added that the user did not see.
 */
export const useDraftSignature = (
	setDrafts: Dispatch<SetStateAction<Draft[]>>,
	activeDraftIndex: number
) => {
	useGetEmailSignatureDefaultQuery();
	const signatureDefault = useAppSelector(emailSignatureDefaultSelector);

	const setActiveIncludeSignature = useCallback(
		(includeSignature: boolean) =>
			setDrafts((prev) =>
				prev.map((draft, index) =>
					index === activeDraftIndex ? { ...draft, includeSignature } : draft
				)
			),
		[setDrafts, activeDraftIndex]
	);

	return { signatureDefault, setActiveIncludeSignature };
};
